import { render, staticRenderFns } from "./TrafficMessageDelayTrainsText.vue?vue&type=template&id=1ab0aeae"
import script from "./TrafficMessageDelayTrainsText.vue?vue&type=script&lang=js"
export * from "./TrafficMessageDelayTrainsText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports